var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "session-wrapper justify-center justify-md-start",
      attrs: {
        "aria-live": "polite"
      }
    },
    [
      _c("div", {
        staticClass: "session-left"
      }),
      _c(
        "div",
        {
          staticClass: "session-right text-center"
        },
        [
          _c(
            "div",
            {
              staticClass: "session-content"
            },
            [
              _c("img", {
                staticClass: "img-responsive mb-3",
                attrs: {
                  id: "focus-target",
                  role: "banner",
                  src: _vm.logotype,
                  tabindex: "0",
                  alt: "Green Geeks logo",
                  "aria-label": "Green Geeks logo",
                  title: "Green Geeks logo"
                }
              }),
              _c(
                "h1",
                {
                  staticClass: "mb-6 login-heading",
                  attrs: {
                    tabindex: "-1"
                  }
                },
                [_vm._v(" Login to Your GreenGeeks Account ")]
              ),
              _vm.errormsg
                ? _c("div", [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          color: "red"
                        },
                        attrs: {
                          role: "alert"
                        }
                      },
                      [_vm._v(_vm._s(_vm.errormsg))]
                    )
                  ])
                : _vm._e(),
              _c(
                "v-form",
                {
                  staticClass: "mb-4",
                  attrs: {
                    "data-vv-scope": "login"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "pa-0"
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: _vm.rules.email,
                                    expression: "rules.email"
                                  }
                                ],
                                attrs: {
                                  label: "E-mail",
                                  outlined: "",
                                  "data-vv-name": "login.email",
                                  "data-vv-as": "Email",
                                  "error-messages": _vm.errors.collect(
                                    "login.email"
                                  )
                                },
                                model: {
                                  value: _vm.model.email,
                                  callback: function callback($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: _vm.rules.password,
                                    expression: "rules.password"
                                  }
                                ],
                                attrs: {
                                  label: "Password",
                                  outlined: "",
                                  type: _vm.passwordFieldType,
                                  "data-vv-name": "login.password",
                                  "data-vv-as": "Password",
                                  "error-messages": _vm.errors.collect(
                                    "login.password"
                                  )
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "append",
                                    fn: function fn() {
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "mt-0 mr-1",
                                            attrs: {
                                              icon: "",
                                              ripple: false,
                                              "aria-label":
                                                _vm.passwordFieldType ===
                                                "password"
                                                  ? "Show password"
                                                  : "Hide password"
                                            },
                                            on: {
                                              click: _vm.togglePasswordField
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "#C2C2C2"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.passwordToggleIcon)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.model.password,
                                  callback: function callback($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "password",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "model.password"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "px-0",
                              attrs: {
                                cols: "12",
                                sm: "6"
                              }
                            },
                            [
                              _c("v-checkbox", {
                                staticClass: "mt-0",
                                attrs: {
                                  ripple: false,
                                  color: "primary",
                                  "aria-label": "Remember me"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function fn() {
                                      return [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "v-label",
                                            staticStyle: {
                                              cursor: "pointer"
                                            },
                                            attrs: {
                                              "aria-hidden": "true"
                                            }
                                          },
                                          [_vm._v("Remember me")]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ]),
                                model: {
                                  value: _vm.model.remember,
                                  callback: function callback($$v) {
                                    _vm.$set(_vm.model, "remember", $$v)
                                  },
                                  expression: "model.remember"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center text-sm-right px-0",
                              attrs: {
                                cols: "12",
                                sm: "6"
                              }
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "pt-1",
                                  attrs: {
                                    to: {
                                      name: "request_reset_password"
                                    }
                                  }
                                },
                                [_vm._v(" Forgot password? ")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    type: "submit",
                                    block: "",
                                    tile: "",
                                    elevation: "0",
                                    dark: "",
                                    large: "",
                                    color: "primary",
                                    loading: _vm.buttons.login
                                  },
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.login(false)
                                    }
                                  }
                                },
                                [_vm._v(" Login ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("cookie-law", {
        attrs: {
          theme: "dark-lime"
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function fn(props) {
              return [
                _c(
                  "p",
                  [
                    _vm._v(
                      " This website uses cookies to ensure you get the best experience on our services. "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.greengeeks.com/legal/privacy",
                          target: "_blank"
                        }
                      },
                      [_vm._v("More details")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ml-md-3",
                        attrs: {
                          color: "primary",
                          tile: ""
                        },
                        on: {
                          click: props.accept
                        }
                      },
                      [_vm._v("Got it!")]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm.otp_required
        ? _c("gg-modal", {
            attrs: {
              "is-active": _vm.otp_required
            },
            on: {
              close: _vm.close2FAModal
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar",
                  fn: function fn() {
                    return [_vm._v(" Two factor authentication ")]
                  },
                  proxy: true
                },
                {
                  key: "title",
                  fn: function fn() {
                    return [_vm._v(" Please insert your 2FA code below ")]
                  },
                  proxy: true
                },
                {
                  key: "body",
                  fn: function fn() {
                    return [
                      _c(
                        "v-form",
                        {
                          attrs: {
                            "data-vv-scope": "otp"
                          },
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                              return _vm.login(true)
                            }
                          }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pb-2",
                                  attrs: {
                                    cols: "12"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.rules.otp,
                                        expression: "rules.otp"
                                      }
                                    ],
                                    attrs: {
                                      label: "Token",
                                      outlined: "",
                                      "data-vv-name": "otp.token",
                                      "data-vv-as": "Token",
                                      "error-messages": _vm.errors.collect(
                                        "otp.token"
                                      )
                                    },
                                    model: {
                                      value: _vm.model.otp,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.model, "otp", $$v)
                                      },
                                      expression: "model.otp"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.otp_error
                                ? _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          attrs: {
                                            type: "error",
                                            dense: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " Your two-factor code is incorrect, please try again. "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "my-0"
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0"
                                },
                                [
                                  _c("p", [
                                    _c("b", [_vm._v("Note:")]),
                                    _vm._v(
                                      " Using a recovery code will disable 2FA protection on your GreenGeeks account."
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function fn() {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            tile: "",
                            type: "submit",
                            loading: _vm.buttons.otp
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              return _vm.login(true)
                            }
                          }
                        },
                        [_vm._v(" Submit ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: ""
                          },
                          on: {
                            click: _vm.close2FAModal
                          }
                        },
                        [_vm._v(" Cancel ")]
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1948224359
            )
          })
        : _vm._e(),
      _vm.email2fa.dialog
        ? _c("email2-f-a", {
            attrs: {
              dialog: _vm.email2fa.dialog
            },
            on: {
              close: _vm.closeEmail2FAModal
            }
          })
        : _vm._e(),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.advanced_otp.step_1.show
        },
        on: {
          close: _vm.closeAOTPStep1Modal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Unknown Device ")]
            },
            proxy: true
          },
          {
            key: "title",
            fn: function fn() {
              return [
                _c(
                  "h2",
                  {
                    staticStyle: {
                      "font-size": "20px"
                    },
                    attrs: {
                      tabindex: "0"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.advanced_otp.step_1.message) + " ")]
                )
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("p", [
                  _vm._v(
                    " You are logging in from an unknown device. A security check is required to proceed. This check involves sending you a one-time password to a known communication method. "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    "Please select your desired communication method below."
                  )
                ]),
                _c(
                  "v-radio-group",
                  {
                    model: {
                      value: _vm.model.method,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model, "method", $$v)
                      },
                      expression: "model.method"
                    }
                  },
                  _vm._l(_vm.advanced_otp.step_1.methods, function(
                    item,
                    index
                  ) {
                    return _c("v-radio", {
                      key: index,
                      attrs: {
                        value: item.value,
                        "aria-label": item.label
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function fn() {
                              return [
                                _c(
                                  "div",
                                  {
                                    attrs: {
                                      "aria-hidden": "true",
                                      tabindex: "-1"
                                    }
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  }),
                  1
                ),
                _vm._v(" Unable to verify? "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#"
                    },
                    on: {
                      click: function click($event) {
                        $event.preventDefault()
                        return _vm.openRecoverAccountModal($event)
                      }
                    }
                  },
                  [_vm._v("Start Recovery")]
                )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "primary",
                      tile: "",
                      loading: _vm.buttons.otp,
                      disabled: !_vm.valueSelected
                    },
                    on: {
                      click: _vm.sendVerificationMethod
                    }
                  },
                  [_vm._v(" Send Code ")]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      text: ""
                    },
                    on: {
                      click: _vm.closeAOTPStep1Modal
                    }
                  },
                  [_vm._v(" Cancel ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.advanced_otp.step_2.show,
          role: "dialog"
        },
        on: {
          close: _vm.closeAOTPStep2Modal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Unknown Device ")]
            },
            proxy: true
          },
          {
            key: "title",
            fn: function fn() {
              return [
                _c(
                  "p",
                  {
                    staticClass: "hide-focus",
                    attrs: {
                      id: "otp-code-dialog-focus",
                      tabindex: "0"
                    }
                  },
                  [_vm._v(_vm._s(_vm.advanced_otp.step_2.message))]
                )
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c(
                  "div",
                  {
                    attrs: {
                      "aria-live": "polite",
                      role: "document"
                    }
                  },
                  [
                    _vm.advanced_otp.step_2.error_message
                      ? _c(
                          "v-alert",
                          {
                            attrs: {
                              type: "error",
                              dense: ""
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.advanced_otp.step_2.error_message) +
                                " "
                            )
                          ]
                        )
                      : _vm._e(),
                    _c("v-text-field", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.code,
                          expression: "rules.code"
                        }
                      ],
                      attrs: {
                        outlined: "",
                        clearable: "",
                        label: "Code",
                        id: "otp-ud2-code",
                        "data-vv-name": "code",
                        "data-vv-as": "Validation code",
                        "error-messages": _vm.errors.collect("code")
                      },
                      on: {
                        keypress: function keypress($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.sendVerificationCode($event)
                        }
                      },
                      model: {
                        value: _vm.model.code,
                        callback: function callback($$v) {
                          _vm.$set(_vm.model, "code", $$v)
                        },
                        expression: "model.code"
                      }
                    }),
                    _vm._v(" I didn’t receive the code. "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#"
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            return _vm.showOtpResendCode($event)
                          }
                        }
                      },
                      [_vm._v("Resend my Code")]
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "primary",
                      tile: "",
                      loading: _vm.buttons.otp
                    },
                    on: {
                      click: _vm.sendVerificationCode
                    }
                  },
                  [_vm._v(" Verify Code ")]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      text: ""
                    },
                    on: {
                      click: _vm.closeAOTPStep2Modal
                    }
                  },
                  [_vm._v(" Cancel ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.advanced_otp.step_3.show
        },
        on: {
          close: _vm.closeAOTPStep3Modal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Recover My Account ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("p", [
                  _vm._v(
                    "Unfortunately no other automated recovery methods are available. If you are not able to access any of the provided verification methods, you will need to work with our team directly to recover your account."
                  )
                ]),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.greengeeks.com/contact",
                      target: "_blank"
                    }
                  },
                  [_vm._v(" Please contact our support team ")]
                ),
                _vm._v(" to start the recovery process. ")
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "primary",
                      tile: ""
                    },
                    on: {
                      click: _vm.closeAOTPStep3Modal
                    }
                  },
                  [_vm._v(" Close ")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }